import type { Petition } from '../types'

export default {
  sf_campaign_id: '70158000000gzpXAAQ',
  title: 'Fri for turbokylling i 2026',
  description: 'Turbokyllingene lider hver eneste dag. Akkurat nå har du en unik mulighet til å endre det. Motta oppdateringer om kampanjen og signer for å få slutt på den grusomme produksjonenen av turbokylling!',
  confirm_email_id: '892',
  image: {
    file_name: 'turbokylling-1.webp',
    credit: 'Andrew Skowron / Anima International',
    alt: 'Turbokyllingen Ross 308',
  },
  sections: [
    {
      title1: 'Din støtte',
      title2: 'betyr alt for turbokyllingen',
      description: 'Butikkjeder og matvareselskaper fra hele verden har allerede lovet å forbedre levekårene til kyllinger i henhold til kravene fastsatt i European Chicken Commitment (ECC). Noen norske produsenter har allerede tatt steget, nå krever vi at resten av bransjen følger etter. Vis at du støtter dette skriftet ved å signere kampanjen i dag.',
      image: {
        file_name: 'turbokylling-1.webp',
        credit: 'Andrew Skowron / Anima International',
        alt: 'Turbokyllingen Ross 308',
      },
    },
    {
      title1: 'Din stemme',
      title2: 'løfter frem kyllingene',
      description: 'Din stemme er ditt sterkeste våpen. Sammen kan vi arbeide for et samfunn der vi ikke tillater fugler hvor 9 av 10 sliter med å gå normalt, og pustevansker, gangproblemer og organsvikt er ‘vanlige’ følgeproblemer. Politikerne følger nøye med på det som er viktig for deg som velger, og økt press på industrien vil tvinge dem til å satse mer på dyrevelferd. Vis dem at omsorg for kyllingene er en sak du brenner for.',
      image: {
        file_name: 'turbokylling-2.webp',
        credit: 'Andrew Skowron / Anima International',
        alt: 'Turbokyllingen Ross 308',
      },
    },
    {
      title1: 'Din signatur',
      title2: 'kan endre norge for alltid',
      description: 'Med din støtte kan vi gjøre Norge til et eksempel å følge for resten av Europa. Landene påvirkes av hverandre, og dyrene trenger deg med på laget for å sette en stopper for den uakseptable og unødvendige lidelsen. Flere produsenter i ulike land har allerede sluttet å selge turbokylling på grunn av de mange helseproblemene til kyllingene. Nå ønsker vi at Norge skal gå frem som et godt eksempel for andre land, og sette kyllinghelse først!',
      image: {
        file_name: 'turbokylling-3.webp',
        credit: 'Andrew Skowron / Anima International',
        alt: 'Turbokyllingen Ross 308',
      },
    },
  ],
  claims: [
    {
      title: 'Jeg vil at fuglene skal kunne gå normalt',
      image_file_name: 'turbokylling-1.webp',
    },
    {
      title: 'Jeg vil at fuglene skal slippe ekstrem vekst',
      image_file_name: 'turbokylling-2.webp',
    },
    {
      title: 'Jeg vil ha slutt på turbokylling',
      image_file_name: 'turbokylling-3.webp',
    },
  ],
} as Petition
